import { ApplicationUser } from "@src/apis/ModularClient";

export class PaySucessController {
  user: ApplicationUser;
  performingAction: boolean;

  static $inject = ["$scope", "$rootScope", "$cookies", "$location"];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
  ) {}

  gotoDashboard() {
    this.$location.path("/userdashboard");
  }
}
